<template>
  <div>
    <v-card  elevation="1" class="pa-0 mt-2">
      <!-- <v-card-title class="font-weight-bold text-subtitle-1 pb-0 summery_info">{{summeryTtile}}</v-card-title> -->
      <v-card-text>
        <v-row no-gutters class="summery_info text-center align-self-center text-subtitle-1">
        <v-col col="3"><span class="font-weight-medium">{{summeryTtile1}}</span><br><span class="text-lg-h6 font-weight-block">{{scnt1}}</span></v-col>
        <v-col col="3"><span class="font-weight-medium">{{summeryTtile2}}</span><br><span class="text-lg-h6 font-weight-block">{{scnt2}}</span></v-col>
        <v-col col="3"><span class="font-weight-medium">{{summeryTtile3}}</span><br><span class="text-lg-h6 font-weight-block">{{scnt3}}</span></v-col>
        <v-col col="3"><span class="font-weight-medium">{{summeryTtile4}}</span><br><span class="text-lg-h6 font-weight-block">{{scnt4}}</span></v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script> 
  export default {
    name: 'SummeryCnt',
    props: {
      scnt1: String, scnt2: String, scnt3: String, scnt4: String,
      summeryTtile: String, summeryTtile1: String, summeryTtile2: String, summeryTtile3: String, summeryTtile4: String
    }
  }
</script>